import React from 'react';
import PropTypes from 'prop-types';
import cautionIcon from '../../images/caution.svg';
import { ResponsiveImage } from '../ResponsiveImage';
import { StyledFeedbackBanner, Paragraph, IconContainer } from './styles.js';

export const FeedbackBanner = ({ header, content, error = false }) => {
  return (
    <StyledFeedbackBanner error={error}>
      <Paragraph error={error}>
        {error && (
          <IconContainer>
            <ResponsiveImage
              src={cautionIcon}
              alt="caution sign"
              width={cautionIcon.width}
              height={cautionIcon.height}
            />
          </IconContainer>
        )}
        {header && <strong>{header}&nbsp;</strong>}
        {content}
      </Paragraph>
    </StyledFeedbackBanner>
  );
};

FeedbackBanner.displayName = 'FeedbackBanner';

FeedbackBanner.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  error: PropTypes.bool,
};
